import { Fragment } from "react";
import { motion } from "framer-motion";
import { Eye, MousePointerClick, Magnet, BellRing, CalendarCheck, BadgeCheck, Repeat } from "lucide-react";

const STEPS = [
    { id: "attention", label: "Attention", icon: Eye },
    { id: "traffic", label: "Traffic", icon: MousePointerClick },
    { id: "lead", label: "Lead", icon: Magnet },
    { id: "followup", label: "Follow-up", icon: BellRing },
    { id: "appointment", label: "Appointment", icon: CalendarCheck },
    { id: "customer", label: "Customer", icon: BadgeCheck },
    { id: "retention", label: "Retention", icon: Repeat },
];

const Node = ({ s }) => (
    <div
        data-testid={`coverage-node-${s.id}`}
        className="flex aspect-square w-full flex-col items-center justify-center gap-2 border-2 border-ink/20 bg-[#FFFDF6] p-2 text-ink transition-all duration-300 hover:-translate-y-1 hover:border-inkblue"
    >
        <s.icon size={20} strokeWidth={1.8} className="text-inkblue" />
        <span className="font-mono text-[10px] font-bold uppercase tracking-[0.14em] sm:text-[11px]">{s.label}</span>
    </div>
);

export const Coverage360 = () => (
    <section id="system" data-testid="coverage-section" className="py-24 lg:py-32">
        <div className="mx-auto max-w-6xl px-5 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            >
                <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-inkblue">360° Digital Coverage</p>
                <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                    The full journey, <span className="highlighter px-1">covered.</span>
                </h2>
                <p className="mt-4 max-w-xl text-base leading-relaxed text-ink/60">
                    Most agencies sell you one slice of the pipeline. We run the whole thing — from first glance to repeat customer.
                </p>
            </motion.div>

            <motion.div
                className="mt-14"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            >
                <div className="hidden items-center lg:flex">
                    {STEPS.map((s, i) => (
                        <Fragment key={s.id}>
                            <div className="flex-1">
                                <Node s={s} />
                            </div>
                            {i < STEPS.length - 1 && <div className="connector-h mx-1.5 w-8 shrink-0 xl:w-12" />}
                        </Fragment>
                    ))}
                </div>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:hidden">
                    {STEPS.map((s) => (
                        <Node key={s.id} s={s} />
                    ))}
                </div>
            </motion.div>
        </div>
    </section>
);
